export const GET_NOTICE_CONTROLS = 'GET_NOTICE_CONTROLS';
export const GET_COURSE_CONTROLS = 'GET_COURSE_CONTROLS';
export const FUNCTION_CONFIG = 'FUNCTION_CONFIG';
